"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var widget_module_scss_1 = __importDefault(require("./widget.module.scss"));
var whatsapp_svg_1 = __importDefault(require("./assets/whatsapp.svg"));
var whatsapp_open_svg_1 = __importDefault(require("./assets/whatsapp-open.svg"));
var chatwidget_svg_1 = __importDefault(require("./assets/chatwidget.svg"));
var chatwidget_close_svg_1 = __importDefault(require("./assets/chatwidget-close.svg"));
var react_i18next_1 = require("react-i18next");
function ChatWidget() {
    var _a = (0, react_1.useState)(false), open = _a[0], setOpen = _a[1];
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: widget_module_scss_1.default.ChatWidget }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: widget_module_scss_1.default.chatCard, 
                // add transition
                style: open
                    ? {
                        bottom: "100px",
                        opacity: "1",
                        visibility: "visible",
                        transition: "ease-in-out 500ms",
                        transform: "translateY(0)",
                    }
                    : {
                        opacity: "0",
                        visibility: "hidden",
                        transition: "ease-in-out 500ms",
                        transform: "translateY(10%)", // Change this value to slide in/out vertically
                    } }, { children: [(0, jsx_runtime_1.jsx)("img", { src: chatwidget_svg_1.default, alt: "Open Chat" }), (0, jsx_runtime_1.jsx)("a", __assign({ href: "https://wa.me/61430345336", target: "_blank" }, { children: (0, jsx_runtime_1.jsxs)("button", __assign({ className: widget_module_scss_1.default.btn }, { children: [(0, jsx_runtime_1.jsx)("img", { src: whatsapp_svg_1.default, alt: "Whatsapp" }), (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "chatButton" })] })) }))] })), open ? ((0, jsx_runtime_1.jsx)("button", __assign({ onClick: function () { return setOpen(false); } }, { children: (0, jsx_runtime_1.jsx)("img", { src: chatwidget_close_svg_1.default, alt: "Close Chat" }) }))) : ((0, jsx_runtime_1.jsx)("button", __assign({ onClick: function () { return setOpen(true); } }, { children: (0, jsx_runtime_1.jsx)("img", { src: whatsapp_open_svg_1.default, alt: "Open Chat" }) })))] })));
}
exports.default = ChatWidget;
